import store from "../storeWire";
import {auth} from "../store/slice/auth";
import axios from "axios";

document.addEventListener('authLiveNotification', function (e) {
    axios.get(window.location.origin + '/api/user').then((user) => {
        store.dispatch(auth(user.data));
        document.getElementById("unreadNotificationCount").innerHTML = user.data.unread_notifications_count;
    });
})


window.toggleSideBar =
    function () {
        let sidebar = document.querySelector('#sidebar');
        sidebar.classList.forEach((v, i) => {
            if (v === 'c-sidebar-lg-show') {
                sidebar.classList.replace('c-sidebar-lg-show', 'c-sidebar-lg-close');
            }
            if (v === 'c-sidebar-lg-show') {
                sidebar.classList.replace('c-sidebar-lg-show', 'c-sidebar-lg-close');
            }
            if (v === 'c-sidebar-lg-close') {
                sidebar.classList.replace('c-sidebar-lg-close', 'c-sidebar-show');
            }
            if (v === 'c-sidebar-show') {
                sidebar.classList.replace('c-sidebar-show', 'c-sidebar-close');
            }
            if (v === 'c-sidebar-close') {
                sidebar.classList.replace('c-sidebar-close', 'c-sidebar-show');
            }
        })
    }
